import React, {useEffect, useState} from 'react'
import MDBox from '../../../components/MDBox';
import {Modal} from '@mui/material';
import {centerHealthInfoIsActive, getCenterHealthInfo, updateHealthInfoIsActive} from '../../../api/routes';
import MDButton from '../../../components/MDButton';
import MDBadge from '../../../components/MDBadge';
import MDInput from '../../../components/MDInput';
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

export default function HealthInformation() {
    const [healthInfo, setHealthInfo] = useState([]);
    const [clickedHealthInfo, setClickedHealthInfo] = useState([]);
    const [updateHealthInfoId, setUpdateHealthInfoId] = useState();
    const [updateHealthInfoText, setUpdateHealthInfoText] = useState('');

    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    useEffect(() => {
        getCenterHealthInfo((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setHealthInfo(data);
        })
    }, [])

    const onLinkChange = (event, infoId) => {
        setClickedHealthInfo({
            ...clickedHealthInfo,
            [infoId]: event.target.checked,
        });
    }
    const submit = (isActive) => {
        const object2arr = Object.keys(clickedHealthInfo).map((key) => ({
            id: Number(key),
            isChecked: clickedHealthInfo[key]
        }));
        const selectedItem = object2arr.filter(item => item.isChecked !== false);

        if (object2arr.length > 0) {
            const data = {
                isActive,
                activeHealthInfo: selectedItem
            }
            centerHealthInfoIsActive(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            })
        } else return toast.error('ابتدا موارد را انتخاب کنید!')
    }

    const updateHealtInfo = () => {
        const data = {
            healthInfoId: updateHealthInfoId,
            text: updateHealthInfoText
        }
        updateHealthInfoIsActive(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload();
        })
    }
    return (
        <>
            <MDBox py={5} px={3}>
                <MDBox mb={2} ml={3}>
                    <MDButton variant="gradient" onClick={() => submit(0)} color="primary"
                              sx={{margin: '0 1rem 0 0'}}>
                        غیر فعال کردن انتخاب شده ها
                    </MDButton>
                    <MDButton variant="gradient" onClick={() => submit(1)} color="info">
                        فعال کردن انتخاب شده ها
                    </MDButton>
                </MDBox>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    marginTop: '2rem'
                }}>
                    {healthInfo.map((item, index) =>
                        <section key={item.healthInfoId} style={{
                            display: 'flex',
                            background: item.isActive ? 'rgb(219 234 254)' : 'rgb(254 226 226)',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            border: '1px solid rgb(209 213 219)',
                            borderRadius: '0.375rem',
                            width: '40%',
                            margin: '0.5rem 1rem 1rem 0',
                            padding: '0.5rem 0.25rem'
                        }}>
                            <section style={{display: 'flex', alignItems: 'center'}}>
                                <input id="checkbox" name={index}
                                       onChange={(event) => onLinkChange(event, item.healthInfoId)} type="checkbox"
                                       style={{
                                           width: '1rem',
                                           height: '1rem',
                                           backgroundColor: '#f3f4f6',
                                           color: '#009dfe',
                                           borderRadius: '0.25rem',
                                           border: '1px solid rgb(209 213 219)'
                                       }}/>
                                <label htmlFor="checkbox" style={{
                                    marginLeft: '8rem',
                                    fontSize: '13px',
                                    paddingRight: '0.5rem',
                                    display: 'flex'
                                }}>{item.text}</label>
                            </section>
                            <MDBox sx={{cursor: "pointer"}} ml={-1} onClick={() => {
                                setUpdateHealthInfoId(item.healthInfoId);
                                setUpdateHealthInfoText(item.text);
                                handleOpen();
                            }}>
                                <MDBadge badgeContent="ویرایش متن" color={"info"} size="lg"/>
                            </MDBox>
                        </section>
                    )}
                </div>
            </MDBox>
            <Modal open={open} onClose={handleClose}>
                <MDBox sx={style}>
                    <MDBox>
                        <MDInput type="text" value={updateHealthInfoText}
                                 onChange={(event) => setUpdateHealthInfoText(event.target.value)} label="متن"
                                 fullWidth/>
                    </MDBox>
                    <MDBox mt={4} mb={1}>
                        <MDButton onClick={updateHealtInfo} variant="gradient" color="info" sx={{width: '120px'}}>
                            ثبت
                        </MDButton>
                    </MDBox>
                </MDBox>
            </Modal>
        </>
    )
}
